import { cva, VariantProps } from 'class-variance-authority'

export type TabsStyling = VariantProps<typeof tabsStyling>

export const tabsStyling = cva('flex gap-1 max-w-fit overflow-x-auto', {
  variants: {
    variant: {
      pill: 'rounded-full p-1 bg-neutral-50',
      plain: '',
    },
  },
  defaultVariants: {
    variant: 'pill',
  },
})
